import PropTypes from "prop-types";
import "../component.css/mobileheader.css"
import { Link } from "react-router-dom";

export default function MobileHeader({onPrev}) {
    return (
        <>
            <header className="Header">
                <Link to="/home">
                <div >
                    <img src="/images/GuardianFieldmaster.png" width="200px"></img>
                </div>
                </Link>
                <button className="back_button"
                    type="button"
                    onClick={() => { if (typeof onPrev === "function") onPrev(); }}
                    style={{ background: "none", border: "none", cursor: "pointer", height: "60px" }}
                    aria-label="뒤로가기"
                >
                    <svg width="22" height="22" viewBox="0 0 24 24">
                        <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </header>
        </>
    )
}

MobileHeader.propTypes = {
    onPrev: PropTypes.func,
};